import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import logo from '../../../assets/img/footer/footer_troy_logo.svg';
import message from '../../../assets/img/footer/footer_smile_message.svg';

const useStyles = makeStyles(theme => ({
  messagePadding: {
    marginLeft: 8,
    paddingBottom: 8
  }
}));

const FooterLogo = ({ className, noLogo }) => {
  const classes = useStyles();

  return (
    <Box className={className}>
      {!noLogo && <img src={logo} alt="troy logo" />}
      <img
        className={!noLogo ? classes.messagePadding : undefined}
        src={message}
        alt="message bubble"
      />
    </Box>
  );
};

export default FooterLogo;
